export default "/profile/images/Prodazhy.svg?27d80e4a63ecd748f522070ac0894e17";